module.exports = __webpack_public_path__ + "img/20190604161443085.3b6b4ba9.png";